import { i18n } from "@/i18n/i18n.config";
import { ValidationSchemas } from "@/libs/base/constants/validation";
import { z } from "zod";

export const contactMessageSchema = z.object({
  fullName: ValidationSchemas.Name,
  email: ValidationSchemas.Email,
  phoneNumber: ValidationSchemas.PhoneNumber,
  message: z.string().trim().min(1),
  language: z.enum(i18n.locales),
});

const cfTurnstileTokenSchema = z.object({
  cfTurnstileToken: z.string().trim().min(1),
});
export const contactMessageWithCfTokenSchema = contactMessageSchema.merge(cfTurnstileTokenSchema);

export type ContactMessageContract = z.infer<typeof contactMessageWithCfTokenSchema>;
